import { jsx as m } from "react/jsx-runtime";
import { Tab as b } from "@chakra-ui/react";
import { CustomTabWithImage as i } from "./tab-with-image.js";
function n({ imgSrc: t, imgAlt: a, imgFallbackColor: f, children: o, ...r }) {
  return t ? /* @__PURE__ */ m(i, { imgAlt: a, imgSrc: t, imgFallbackColor: f, ...r, children: o }) : /* @__PURE__ */ m(b, { ...r, children: o });
}
export {
  n as Tab
};
